import type { FaireProductEntity } from "../../entity_types/product";

export const p_8c48nqb6ug: FaireProductEntity = {
  token: "p_8c48nqb6ug",
  type: "product",
  name: "Sis Knit Sweater, Amour",
  brandToken: "b_4ivwmhbmyd",
  brandName: "SpearmintLOVE",
  imageUrl:
    "https://cdn.faire.com/fastly/8e3ae89f05dbdee103b0256753d6031e5f1b4d6891d49989736beb08c0056ad7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ccbcf2cacfe95cd5598701925518d7461df5a04ae75819e8f4105b7de5a76015.jpeg",
  ],
  priceDollars: 21,
  description:
    "\nFor the sweetest Sister! These cozy knit sweaters are perfectly oversized and made from 100% sheep wool. \n\n * Made from 100% Sheep Wool \n * Imported \nCARE INSTRUCTIONS\n\nWashing: hand wash recommended\nDry cleaning: do not dry clean\nBleaching: do not bleach\nDrying: hang dry\n",
  tags: [],
  msrpDollars: 42,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:43.409Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
